/* eslint complexity: 0 */
/* eslint max-statements: 0 */

const SECOND = 1000;
const MINUTE = 60 * SECOND;

const SYNC_INTERVAL = 5 * MINUTE;
const SYNC_DRIFT = 2 * MINUTE;
const SYNC_TIMEOUT = 10 * SECOND;

const TICK_INTERVAL = 100;
const MAX_TICK_DELAY = 2 * SECOND;

export default class Timer {
    constructor({ eventDate, onEvent, onTick, sync }) {
        this.onEvent = onEvent;
        this.onTick = onTick;
        this.sync = sync;
        this._readyToSync = true;
        this._eventDate = new Date(`${new Date(eventDate).toISOString().slice(0, 19)}Z`);

        this._sync();
    }

    destroy = () => {
        clearInterval(this._syncInterval);
        clearInterval(this._tickInterval);
    };

    _sync = () => {
        this._readyToSync = false;

        this.sync(this._eventDate).then((time) => {
            this._computedDate = Date.now();
            this._time = time;

            const syncDrift = Math.random() * SYNC_DRIFT;
            const syncInterval = SYNC_INTERVAL + syncDrift;

            this.destroy();

            this._syncInterval = setInterval(this._sync, syncInterval);
            this._tickInterval = setInterval(this._tick, TICK_INTERVAL);

            this._tick();

            setTimeout(() => (this._readyToSync = true), SYNC_TIMEOUT);
        });
    };

    _tick = () => {
        const delta = Date.now() - this._computedDate;
        const ms = this._time % 1000;

        // Что-то пошло не так
        if ((delta > MAX_TICK_DELAY || delta < 0) && this._readyToSync) {
            this.destroy();
            this._sync();

            return;
        }

        this._time -= delta;
        this._computedDate += delta;

        // Таймер закончился
        if (this._time <= 0) {
            // Останавливаем таймер
            this.destroy();

            if (this.onEvent) {
                this.onEvent();
            }
        }

        // Секунда прошла
        if (ms + delta >= 1000 && this._time > 0) {
            if (this.onTick) {
                this.onTick(this._time);
            }
        }
    };
}
